import React from 'react';
import { CheckCircle, Copy } from 'lucide-react';
import toast from 'react-hot-toast';

function CopyField({ label, value }) {
  if (!value) return (
    <div>
      <div className="text-[10px] uppercase tracking-wider text-white/40">{label}</div>
      <div className="font-mono text-xs text-white/40">—</div>
    </div>
  );
  return (
    <div>
      <div className="text-[10px] uppercase tracking-wider text-white/40">{label}</div>
      <button
        type="button"
        onClick={() => {
          navigator.clipboard?.writeText(value);
          toast.success(`${label} copied`);
        }}
        className="font-mono text-xs text-white inline-flex items-center gap-1.5 hover:text-civix-purple transition"
      >
        {value} <Copy className="w-3 h-3 opacity-60" />
      </button>
    </div>
  );
}

export default function A2PBrandSummaryCard({ brand }) {
  if (!brand) return null;
  const approved = String(brand.brandStatus || '').toUpperCase() === 'APPROVED'
    || String(brand.brandStatus || '').toUpperCase() === 'VERIFIED';
  return (
    <div className="panel p-5 space-y-4">
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="font-display font-bold text-lg">{brand.legalBusinessName || 'Business profile'}</div>
          <div className="text-xs text-white/50 mt-0.5">Single registered brand for this tenant.</div>
        </div>
        {approved && (
          <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs bg-emerald-500/15 text-emerald-300 border border-emerald-500/40">
            <CheckCircle className="w-3.5 h-3.5" /> Approved
          </div>
        )}
      </div>
      <div className="grid md:grid-cols-3 gap-4 pt-2 border-t border-civix-border/40">
        <CopyField label="Brand SID" value={brand.brandSid} />
        <CopyField label="Customer Profile SID" value={brand.customerProfileSid} />
        <div>
          <div className="text-[10px] uppercase tracking-wider text-white/40">Trust Score</div>
          <div className="font-display font-bold text-2xl gradient-text">{brand.trustScore || 0}</div>
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-4 pt-2 border-t border-civix-border/40">
        <div>
          <div className="text-[10px] uppercase tracking-wider text-white/40">T-Mobile Daily SMS Limit</div>
          <div className="text-sm font-mono">{(brand.tMobileDailySmsLimit || 0).toLocaleString()} / day</div>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-wider text-white/40">Branded Calling</div>
          <div className="text-sm">{brand.brandedCalling?.displayName || '—'}</div>
        </div>
      </div>
      {brand.sampleMessages?.length > 0 && (
        <div className="pt-2 border-t border-civix-border/40">
          <div className="text-[10px] uppercase tracking-wider text-white/40 mb-2">Sample Text Messages</div>
          <ul className="space-y-1.5 text-sm text-white/75">
            {brand.sampleMessages.slice(0, 2).map((m, i) => (
              <li key={i} className="font-mono text-xs leading-relaxed">{m}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
